"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

var components_1 = require("@lsg/components");

var FragmentRenderer_1 = require("./node/FragmentRenderer");

var util_1 = require("./entry-item/util");

var FootnoteRenderer_1 = require("./entry-item/FootnoteRenderer");

exports.createSimpleComponentRendererFor = function (component, componentProps) {
  if (componentProps === void 0) {
    componentProps = {};
  }

  var Component = component;
  return function (node, children) {
    return React.createElement(Component, __assign({}, componentProps), children);
  };
};

exports.h1Renderer = exports.createSimpleComponentRendererFor(components_1.H1);
exports.h2Renderer = exports.createSimpleComponentRendererFor(components_1.H2);
exports.h3Renderer = exports.createSimpleComponentRendererFor(components_1.H3);
exports.h4Renderer = exports.createSimpleComponentRendererFor(components_1.H4);
exports.h5Renderer = exports.createSimpleComponentRendererFor(components_1.H5);
exports.paragraphRenderer = exports.createSimpleComponentRendererFor(components_1.Paragraph);
exports.unorderedListRenderer = exports.createSimpleComponentRendererFor(components_1.List);
exports.orderedListRenderer = exports.createSimpleComponentRendererFor(components_1.List, {
  isOrdered: true
});
exports.embeddedFootnoteRenderer = util_1.composeEntryLinkRendererUsing({
  Footnote: FootnoteRenderer_1.renderFootnote
});
/**
 * NOTE(benjamin): Using this configuration will render all blocks as plain
 * React fragments.
 * Main use case is a Contentful richtext field which allows no block elements
 * and is only used for rendering embedded footnote entries.
 */

exports.footnotesFragmentsOptions = {
  renderNode: (_a = {}, _a[rich_text_types_1.BLOCKS.HEADING_1] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.HEADING_2] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.HEADING_3] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.HEADING_4] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.HEADING_5] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.PARAGRAPH] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.UL_LIST] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.OL_LIST] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.BLOCKS.LIST_ITEM] = FragmentRenderer_1.renderFragment, _a[rich_text_types_1.INLINES.EMBEDDED_ENTRY] = exports.embeddedFootnoteRenderer, _a)
};